import { Button } from "@/components/ui/button";
import { Target, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Welcome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-hero flex flex-col items-center justify-center p-4 pb-24">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Logo */}
        <div className="space-y-3 animate-fade-in-up">
          <img
            src="/logo.png"
            alt="SmartPoker"
            className="w-20 h-20 rounded-2xl mx-auto shadow-glow"
          />
          <h1 className="text-4xl font-bold text-white tracking-tight">
            {t("welcome_title")}
          </h1>
          <p className="text-white/70 text-lg">{t("welcome_tagline")}</p>
        </div>

        {/* Value Props */}
        <div
          className="space-y-3 animate-fade-in-up"
          style={{ animationDelay: "100ms" }}
        >
          <div className="glass p-4">
            <div className="flex items-start gap-3 text-left">
              <div className="bg-secondary/20 p-2 rounded-xl shrink-0">
                <Target className="w-5 h-5 text-secondary" />
              </div>
              <div>
                <h3 className="font-semibold text-white mb-0.5">
                  {t("welcome_strategic_title")}
                </h3>
                <p className="text-sm text-white/60">
                  {t("welcome_strategic_desc")}
                </p>
              </div>
            </div>
          </div>

          <div className="glass p-4">
            <div className="flex items-start gap-3 text-left">
              <div className="bg-accent/20 p-2 rounded-xl shrink-0">
                <Users className="w-5 h-5 text-accent" />
              </div>
              <div>
                <h3 className="font-semibold text-white mb-0.5">
                  {t("welcome_global_title")}
                </h3>
                <p className="text-sm text-white/60">
                  {t("welcome_global_desc")}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div
          className="space-y-3 animate-fade-in-up"
          style={{ animationDelay: "200ms" }}
        >
          <Button
            size="lg"
            className="w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold shadow-glow text-lg h-14"
            onClick={() => navigate("/register")}
          >
            {t("welcome_cta_register")}
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="w-full border-white/20 text-white hover:border-secondary hover:text-secondary hover:bg-secondary/10"
            onClick={() => navigate("/login")}
          >
            {t("welcome_cta_login")}
          </Button>
        </div>

        <p className="text-white/40 text-xs animate-fade-in-up" style={{ animationDelay: "300ms" }}>
          {t("welcome_free_chips")}
        </p>
      </div>
    </div>
  );
};

export default Welcome;
